import DropdownLists from "../../components/DropdownLists.json";

export default [
  // {
  //   key: 'id',
  //   label: 'ID',
  //   sortable: true
  // },
  {
    key: 'event_date',
    label: 'Event Date',
    sortable: true
  },
  // {
  //   key: 'calendar',
  //   label: 'Calendar',
  //   sortable: true
  // },
  {
    key: 'district',
    label: 'District',
    sortable: true
  },
  {
    key: 'low_grade',
    label: 'Grade Range',
    sortable: false,
    formatter (value, key, item) {
      let low = DropdownLists.gradeList[value] ? DropdownLists.gradeList[value] : 'Pre-K'
      let high = DropdownLists.gradeList[item?.high_grade] ? DropdownLists.gradeList[item.high_grade] : '12+'
      return low + ' - ' + high
    }
  },
  {
    key: 'event_type',
    label: 'Event Type',
    sortable: true,
    formatter (value) {
      return value.includes('undefined') ?  '' : DropdownLists.eventList[value]
    }
  },
  {
    key: 'time',
    label: 'Time',
    sortable: false,
  },
  {
    key: 'building',
    label: 'Building',
    sortable: true,
    formatter (value) {
      value = value ?  value.name : '';
      return value?.slice(0, 20) + (value?.length > 20 ? '...' : '')
    }
  },
  {
    key: 'notes',
    label: 'Notes',
    sortable: true,
    formatter (value) {
      value = value ?  value : '';
      return value?.slice(0, 20) + (value?.length > 20 ? '...' : '')
    }
  },
  {
    key: 'created_at',
    label:'Time Entered',
    sortable: true,
  },
  { key: 'actions', 
    label: 'Actions' 
  }
]
